import { render, staticRenderFns } from "./SiteChangerDropdown.vue?vue&type=template&id=64bac275&scoped=true&"
import script from "./SiteChangerDropdown.vue?vue&type=script&lang=js&"
export * from "./SiteChangerDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bac275",
  null
  
)

export default component.exports